module.exports = __webpack_public_path__ + "static/media/icon-shrink-order.ae2602e1.svg";